export default __webpack_public_path__ + "static/media/icon-chevron.60d90c9f.svg";